import { PrimaryNavTabsEnum } from '../../types';

function getCurrentPathTab(): PrimaryNavTabsEnum | null {
  return PrimaryNavTabsEnum.STOCK;
}

export default getCurrentPathTab;
